import React from 'react';
import './WorkingProcess.css';

const WorkingProcess = () => {
  const processSteps = [
    {
      id: 1,
      number: '01',
      title: 'Meet The Client',
      description: 'We discuss your vision, preferences, and requirements to understand your celebration needs',
      icon: (
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          <path d="M9 11h6M9 15h6" strokeWidth="2"/>
          <ellipse cx="9" cy="13" rx="3" ry="1.5" fill="currentColor" opacity="0.3"/>
        </svg>
      )
    },
    {
      id: 2,
      number: '02',
      title: 'Make Ideas',
      description: 'Our creative team designs unique concepts and themes tailored to your special occasion',
      icon: (
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <rect x="3" y="8" width="18" height="12" rx="2"></rect>
          <path d="M3 10h18M7 8V6a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2"></path>
          <circle cx="9" cy="14" r="1"></circle>
          <circle cx="15" cy="14" r="1"></circle>
          <path d="M12 14v2M6 14h12"></path>
        </svg>
      )
    },
    {
      id: 3,
      number: '03',
      title: 'Development',
      description: 'We bring your vision to life with meticulous planning and professional execution',
      icon: (
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <rect x="3" y="3" width="18" height="18" rx="2"></rect>
          <line x1="12" y1="3" x2="12" y2="21"></line>
          <line x1="3" y1="12" x2="21" y2="12"></line>
          <circle cx="8" cy="8" r="1.5" fill="currentColor"></circle>
          <circle cx="16" cy="8" r="1.5" fill="currentColor"></circle>
          <circle cx="8" cy="16" r="1.5" fill="currentColor"></circle>
          <circle cx="16" cy="16" r="1.5" fill="currentColor"></circle>
        </svg>
      )
    },
    {
      id: 4,
      number: '04',
      title: 'Perfect Execution',
      description: 'Your celebration is beautifully decorated and ready to create unforgettable memories',
      icon: (
        <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <path d="M9 21h6M12 3a6 6 0 0 1 6 6c0 2.5-1.5 4.5-3 6"></path>
          <path d="M12 3a6 6 0 0 0-6 6c0 2.5 1.5 4.5 3 6"></path>
          <path d="M12 15v3"></path>
          <path d="M8.5 10.5L10 12l2-1.5L14 12l1.5-1.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )
    }
  ];

  return (
    <section id="process" className="working-process-section">
      <div className="process-background">
        <div className="process-background-overlay"></div>
      </div>
      <div className="process-container">
        <div className="process-header">
          <h2 className="process-title">
            <span className="title-part-1">Our Working</span>
            <span className="title-part-2">Process</span>
          </h2>
          <p className="process-subtitle">
            From concept to celebration, we make your special moments extraordinary
          </p>
        </div>
        
        <div className="process-steps">
          {processSteps.map((step, index) => (
            <div 
              key={step.id} 
              className="process-card"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              <div className="card-number">{step.number}</div>
              <div className="card-icon">{step.icon}</div>
              <h3 className="card-title">{step.title}</h3>
              <p className="card-description">{step.description}</p>
              {index < processSteps.length - 1 && (
                <div className="process-arrow">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WorkingProcess;
